
const exceptionsConstants = {
    INITTING_DELETED_PROJECT: 'INITTING_DELETED_PROJECT'
};

export default exceptionsConstants;
